<template>
  <CContainer class="d-flex align-items-center min-vh-100">
    <CRow class="w-100 justify-content-center">
      <CCol md="6">
        <div class="w-100" v-if="$store.state.idUsuario">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">¡Uy! Algo salio mal.</h4>
            <p class="text-muted">No se encontró la página que está buscando.</p>
          </div>
          <hr>
          <div class="clearfix">
            <CButton color="primary" class="px-4 m-2" to="/">Regresar al Inicio</CButton>
          </div>
        </div>
        <div class="w-100" v-else>
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4"><i class="fas fa-lock"></i></h1>
            <h4 class="pt-3">Al parecer está intentando iniciar una sesión desde una dirección no válida!.</h4>
            <h5 class="mt-5 text-muted">Intente nuevamente ingresando desde la página web de la Institución Educativa o verifique que la dirección (URL) que le suministraron este bien escrita.</h5>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
  export default {
    name: 'Page404'
  }
</script>
